import script from "./TableSection.vue?vue&type=script&setup=true&lang=js"
export * from "./TableSection.vue?vue&type=script&setup=true&lang=js"

import "./TableSection.vue?vue&type=style&index=0&id=33ec30c5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33ec30c5"]])

export default __exports__